<div class="d-flex align-items-center justify-content-center">
    <div class="modal-container2 row modal-md percent_35 ">

        <div class="modal-container-header col-12">
            <span *ngIf="pantalla !== 'edtDatosRecepcion' && pantalla !== 'gestion-terceros-register'" class="text-new-14">
                {{ 'gestion_vehiculos.popup.ordenesAbiertas' | translate }}
            </span>
            <span *ngIf="pantalla === 'edtDatosRecepcion' || pantalla === 'gestion-terceros-register'" class="text-new-14">{{ title | translate }}</span>
            <span class="k-icon k-i-close" (click)="closeModal('cerrar')"></span>
        </div>

        <div class="modal-container-section col-12 pt-1">
            <span *ngIf="(pantalla === 'edtDatosRecepcion' || pantalla === 'gestion-terceros-register') && _authService.getDataPais() == 'es' && updateDetails">
                Se ha actualizado el Cod. IVA del cliente, la actualizacion de documentos puede demorar mucho
            </span>

            <div class="row">
                <div class="col-12">
                    <dms-generic-table [dataTable]='dataTable' [selectable]='true' [hasPage]='false'
                        (selectAccount)="getRow($event)">
                    </dms-generic-table>
                </div>
            </div>
            <div class="modal-background"></div>
            <div class="modal-container-buttons row justify-content-center">
                <div class="col-12" *ngIf="mostrarBotones()">
                    <label class="color_grey" title="{{'gestion_vehiculos.popup.deseaModificar' | translate}}">
                        {{'gestion_vehiculos.popup.deseaModificar' | translate}}</label>
                </div>

                <div class="modal-footer p-0" *ngIf="mostrarBotones()">
                    <button type="button" class="btn btn-secondary verde_con_efecto border_all"
                        (click)="closeModal('guardar')">
                        <span class="k-icon k-i-check-circle text-size-big"></span>
                        {{ 'labels.si' | translate}}
                    </button>

                    <button type="button" class="btn btn-secondary float-right  rojo_con_efecto"
                        (click)="closeModal('cerrar')">
                        <span class="k-icon k-i-close-circle  text-size-big"></span>
                        {{ 'labels.no' | translate}}
                    </button>

                </div>

                <div class="modal-footer p-0" *ngIf="pantalla === 'recepcionVehiculo'">

                    <button type="button" class="btn btn-secondary  verde_con_efecto border_all"
                        [disabled]="!selectedOrder" (click)="closeModal('gestionOr')">
                        <span class="k-icon k-i-check-circle text-size-big"></span>
                        {{ 'labels.gestion_or' | translate}}
                    </button>

                </div>
            </div>

        </div>
    </div>
</div>
